import { toast } from "react-toastify";
import moment from "moment";

export function ValidaBlur(
  value,
  data_usuario,
  Get_Data_Change_F,
  Errores,
  setErrores,
  key
) {
  if (key === "nombres") {
    if (value === "" || value === null) {
      toast.error("El nombre es obligatorio.");
      setErrores({
        ...Errores,
        nombres: true,
      });
      return;
    }
    setErrores({
      ...Errores,
      nombres: false,
    });
  } else if (key === "apellido_p") {
    if (value === "" || value === null) {
      toast.error("El apellido paterno es obligatorio.");
      setErrores({
        ...Errores,
        apellido_p: true,
      });
      return;
    }
    setErrores({
      ...Errores,
      apellido_p: false,
    });
  } else if (key === "fecha_nacimiento") {
    if (value !== "" && value !== null) {
      let anio = moment(value).format("YYYY");
      if (anio < 1900) {
        toast.error("La fecha de nacimiento es inválida.");
        setErrores({
          ...Errores,
          fecha_nacimiento: true,
        });

        Get_Data_Change_F({
          ...data_usuario,
          fecha_nacimiento: "",
        });

        return;
      } else {
        let hoy = new Date();
        let edad = moment(hoy).diff(value, "years");
        if (edad < 18) {
          toast.error("Debe tener al menos 18 años.");
          setErrores({
            ...Errores,
            fecha_nacimiento: true,
            apellido_p: false,
          });
          Get_Data_Change_F({
            ...data_usuario,
            fecha_nacimiento: "",
          });

          return;
        } else if (edad > 120) {
          toast.error("La fecha de nacimiento es inválida.");
          setErrores({
            ...Errores,
            fecha_nacimiento: true,
          });
          Get_Data_Change_F({
            ...data_usuario,
            fecha_nacimiento: "",
          });

          return;
        }
      }
      setErrores({
        ...Errores,
        fecha_nacimiento: false,
      });
    } else {
      toast.error("La fecha de nacimiento es obligatoria.");
      setErrores({
        ...Errores,
        fecha_nacimiento: true,
      });
    }
  } else if (key === "sexo") {
    if (value === "" || value === null) {
      toast.error("El sexo es obligatorio.");
      setErrores({
        ...Errores,
        sexo: true,
      });
      return;
    }
    setErrores({
      ...Errores,
      sexo: false,
    });
  } else if (key === "genero") {
    if (value === "" || value === null) {
      toast.error("El género es obligatorio.");
      setErrores({
        ...Errores,
        genero: true,
      });
      return;
    }
    setErrores({
      ...Errores,
      genero: false,
    });
  } else if (key === "telefono_uno") {
    if (value === "" || value === null) {
      toast.error("El teléfono es obligatorio.");
      setErrores({
        ...Errores,
        telefono_uno: true,
      });
      return;
    }
    setErrores({
      ...Errores,
      telefono_uno: false,
    });
  } else if (key === "isapre") {
    if (value === "" || value === null) {
      toast.error("La isapre es obligatoria.");
      setErrores({
        ...Errores,
        isapre: true,
      });
      return;
    }
    setErrores({
      ...Errores,
      isapre: false,
    });
  } else if (key === "email") {
    let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let testemail = re.test(String(value).toLowerCase());

    if (!testemail) {
      toast.error("El formato del email es inválido.");
      setErrores({
        ...Errores,
        email: true,
      });
      return;
    }

    if (value === "" || value === null) {
      toast.error("El email es obligatorio.");
      setErrores({
        ...Errores,
        email: true,
      });
      return;
    } else if (data_usuario.email2 !== "" && data_usuario.email2 !== null) {
      if (value !== data_usuario.email2) {
        toast.error("Los email no coinciden.");
        setErrores({
          ...Errores,
          email: true,
        });
        return;
      }
    }

    setErrores({
      ...Errores,
      email: false,
    });
  } else if (key === "email2") {
    let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let testemail = re.test(String(value).toLowerCase());

    if (!testemail) {
      toast.error("El formato del email es inválido.");
      setErrores({
        ...Errores,
        email2: true,
      });
      return;
    }

    if (value === "" || value === null) {
      toast.error("Confirme su email.");
      setErrores({
        ...Errores,
        email2: true,
      });
      return;
    } else if (value !== data_usuario.email) {
      toast.error("Los email no coinciden.");
      setErrores({
        ...Errores,
        email2: true,
      });
      return;
    }
    setErrores({
      ...Errores,
      email2: false,
    });
  } else if (key === "region") {
    if (value === "" || value === null) {
      toast.error("La región es obligatoria.");
      setErrores({
        ...Errores,
        region: true,
      });
      return;
    }
    setErrores({
      ...Errores,
      region: false,
    });
  } else if (key === "comuna") {
    if (value === "" || value === null) {
      toast.error("La comuna es obligatoria.");
      setErrores({
        ...Errores,
        comuna: true,
      });
      return;
    }
    setErrores({
      ...Errores,
      comuna: false,
    });
  } else if (key === "direccion_via") {
    if (value === "" || value === null) {
      toast.error("La dirección vía es obligatoria.");
      setErrores({
        ...Errores,
        direccion_via: true,
      });
      return;
    }
    setErrores({
      ...Errores,
      direccion_via: false,
    });
  } else if (key === "direccion_nombre") {
    if (value === "" || value === null) {
      toast.error("La dirección es obligatoria.");
      setErrores({
        ...Errores,
        direccion_nombre: true,
      });
      return;
    }
    setErrores({
      ...Errores,
      direccion_nombre: false,
    });
  } else if (key === "direccion_nro") {
    if (value === "" || value === null) {
      toast.error("El número de dirección es obligatorio.");
      setErrores({
        ...Errores,
        direccion_nro: true,
      });
      return;
    }
    setErrores({
      ...Errores,
      direccion_nro: false,
    });
  } else if (key === "nacionalidad") {
    if (value === "" || value === null) {
      toast.error("La nacionalidad es obligatoria.");
      setErrores({
        ...Errores,
        nacionalidad: true,
      });
      return;
    }
    setErrores({
      ...Errores,
      nacionalidad: false,
    });
  }
}
